<template>
  <div @contextmenu.prevent class="pt20 pb40 book-preview-container" v-loading.fullscreen="ebookChapterHtml.state === 'loading'"
       element-loading-text="拼命加载中..."
       element-loading-spinner="el-icon-loading"
       custom-class="loading-container"
       element-loading-background="rgba(0, 0, 0, 0.6)">
    <div class="book-catalog c-333 bgc-grey pt20">
      <el-tree
        :data="ebookChapterList.chapters"
        :props="defaultProps"
        :expand-on-click-node="false"
        node-key="id"
        default-expand-all
      >
        <div class="toc-item" :class="{
            'nav-level-1': data.parent_id === null,
            'nav-level-2': data.parent_id !== null
          }"
             slot-scope="{node, data}">
          <div class="chapterContent wd240">
            <router-link :to="{
              name: $route.name,
              query: extend({}, $route.query, {
                ebook_category_content_id: data.ebook_category_content_id||data.user_ebook_category_content_id,
                anchor: data.anchor,
                type: $route.query.type ? $route.query.type : '',
              })
           }"
                         :class="{'current': currentSelectedCategory === (data.ebook_category_content_id + data.anchor)}"
                         replace
                         :title="data.title" class="db" >
          <span class="chapter_content user-select" :class="{
          'c-grey':data.is_free===0&&$access.hasRole(['publishAdministrator', 'publishContentAdministrator']),
          'color-grey':data.is_free===0&&data.is_permission===0&&!$access.hasRole(['publishAdministrator', 'publishContentAdministrator'])
          }">{{node.label}}</span>
            </router-link>
          </div>
          <div class="chapterContent chapter_content_right" v-if="data.is_free==0 && !isPublicEbook" @click="setFree(1,data.id)">
            <el-tag size="medium"  class="freeChapter" @click="setFree(1,data.id)">免费试读</el-tag>
          </div>
          <div class="chapterContent chapter_content_right" v-if="data.is_free==1 && !isPublicEbook" @click="setFree(0,data.id)">
            <el-tag size="medium" class="notFreeChapter" @click="setFree(0,data.id)">取消试读</el-tag>
          </div>
        </div>
      </el-tree>
    </div>
    <div class="book-render" >
      <div class="dn user-select" v-html="pageCss"></div>
      <div class="ebookhtml user-select"
           v-html="ebookChapterHtml.category_content"
           ref="book_container"
           @click.stop.prevent="clickWhenHtml($event)"
           v-if="ebookChapterHtml.is_permission===1"
           v-viewer="viewOptions"
      ></div>
      <div class="ebookhtml align-center user-select"
           ref="book_container"
           @click.stop.prevent="clickWhenHtml($event)"
           v-if="ebookChapterHtml.is_permission===0"
      >当前章节为付费章节，是否立即付费阅读
        <el-button  @click="buyBook()" class="fz24 c-red" type="text">购买本书</el-button>
      </div>
      <div class="view-next-btn">
        <router-link :to="{
          name: $route.name,
          query: {
            ebook_id: $route.query.ebook_id,
            ebook_category_content_id: nextCategoryId,
            type: $route.query.type ? $route.query.type : '',
          }
        }" replace class="current" v-if="nextCategoryId" >继续阅读</router-link>
      </div>
    </div>
    <el-dialog title="购买" :visible.sync="bookPurchaseVisible" width="800px">
      <div class="dialog_height">
        <p class="dialog_p">商品信息</p>
        <div class="dialog_detail mt20">
          <el-row :gutter="20">
            <el-col :span="6">
              <img class="dialog_img" :key="eBookDetailData.picture" alt=""  v-lazy="eBookDetailData.picture">
            </el-col>
            <el-col :span="12">
              <p class="mt10 dialog_name">{{eBookDetailData.ebook_name}}</p>
              <p class="mt20">{{eBookDetailData.author_name}}</p>
            </el-col>
            <el-col :span="6">
              <p class="c-red dialog_price">￥{{eBookDetailData.ebook_price}}</p>
            </el-col>
          </el-row>
        </div>
        <div class="fr mt20 dialog_div" v-if="eBookDetailData.is_sale === 0">
          <p>应付：<span class="ml10">-￥</span><span class="c-red dialog_name">{{eBookDetailData.ebook_price}}</span></p>
          <p class="mt20"><el-button size="mini" type="danger" @click="submitOrder">提交订单</el-button></p>
        </div>
        <div class="fr mt20 dialog_div" v-if="eBookDetailData.is_sale === 1">
          <p>商品定价：<span class="ml10">-￥</span><span>{{eBookDetailData.ebook_price}}</span></p>
          <p class="mt10">折扣优惠：<span class="ml10">-￥</span><span>{{eBookDetailData.ebook_discount | preferential(eBookDetailData.ebook_price)}}</span></p>
          <p class="mt10">应付：<span class="ml10">-￥</span><span class="c-red dialog_name">{{eBookDetailData.ebook_discount | price(eBookDetailData.ebook_price)}}</span></p>
          <p class="mt20"><el-button size="mini" type="danger" @click="submitOrder">提交订单</el-button></p>
        </div>
      </div>
    </el-dialog>

    <Purchase v-if="purchase == 2" :render-data="goods"></Purchase>
  </div>
</template>

<script>
  import {
    extend,
    map,
    filter,
    each,
    keyBy,
    mapValues,
    isEmpty
  }  from 'lodash-es'
  import {
    mapGetters,
    mapActions
  } from 'vuex';
  import 'src/common/Viewer';

  export default {
    data() {
      return {
        bookPurchaseVisible: false,
        purchase: 1,
        defaultProps: {
          children: 'children',
          label: 'title'
        },
      };
    },
    props: {
      queryParams: {
        type: Object,
        default: function () {
          return {}
        },
      },
    },
    computed: {
      ...mapGetters({
        'user': '__get_user_info',
        'ebookChapterList': 'getEbookChapterList',//电子书章节信息
        'ebookChapterHtml': 'getEbookChapterHtml',//电子书章节内容
        'eBookDetailData': 'getPublisherEBookDetailData',//详情
      }),
      viewOptions(){
        let preventFn = function(el){
          el.oncontextmenu = function(e) {
            e.preventDefault();
          }
        };
        return {
          viewed(e) {
            let image = e.detail.image;
            preventFn(image);
          }
        }
      },
      isShow(){
        return this.ebookChapterHtml.is_permission===1
      },
      goods() {
        return {id: this.eBookDetailData.id, type: 'ebook', total: 1}
      },
      pageCss() {
        let content = this.ebookChapterHtml;
        let linkStr = map(filter(content.links, (item) => item.type === 'text/css'), function (item) {
          if (item.url) {
            return `<link href="${item.url}" rel="stylesheet" />`;
          } else if (item.content) {
            return `<style type="text/css">${item.content}</style>`;
          }
          return '';
        });
        return linkStr.join('');
      },
      isPublicEbook() {
        return this.$route.name.indexOf('e_book') != -1;
      },
      currentSelectedCategory() {
        let routeQuery = this.$route.query;
        return routeQuery.ebook_category_content_id + routeQuery.anchor;
      },
      nextCategoryId() {
        let nav = this.eBookDetailData.nav;
        let ebook_category_content_id = parseInt(this.$route.query.ebook_category_content_id || nav[0]);
        if (!isNaN(ebook_category_content_id)) {
          let index = nav.indexOf(ebook_category_content_id);
          return nav[index + 1];
        }
        return false;
      },
      categoryFileAndId() {
        return mapValues(keyBy(this.ebookChapterList.list, 'file_name'), it=>it.ebook_category_content_id);
      }
    },
    watch: {
      $route(to, from){
        let toQuery = to.query;
        if (toQuery.ebook_category_content_id !== from.query.ebook_category_content_id) {
          this.getChapter({
            ebook_id: toQuery.ebook_id,
            ebook_category_content_id: toQuery.ebook_category_content_id,
            type:toQuery.type
          });
        } else {
          this.anchorToPosition();
        }
      }
    },
    methods: {
      extend,
      ...mapActions({
        'actionEbookChapterHtml': 'actionEbookGetChapterHtmlPort',//电子书章节内容
        'actionEbookChapterList': 'actionEbookGetChapterListPort',//电子书章节信息
        'publisherEBookGetDetailDataPort': 'actionEBookGetDetailDataPort',//电子书详情
        'actionEBookSetFree':'actionEBookSetFreePort',//电子书设置免费
      }),
      buyBook(){
        if(this.user){
          this.bookPurchaseVisible = true;
          this.purchase = 1
        }else {
          this.$alert('检测到您当前还未登录，是否立即登录完成购买', '购买电子书', {
            confirmButtonText: '确定',
            callback: action => {
              if(action==='confirm') {
                this.$router.push({name: 'user_login'})
              }
            }
          });
        }
      },
      clickWhenHtml(event) {
        let target = event.target;
        let tag = target.tagName.toLowerCase();

        switch (tag) {
          case 'a': {
            let categoryFileAndId = this.categoryFileAndId;
            let [url, anchor] = (target.getAttribute('href') || '').split('#');
            let routeObj = {};
            if (url && categoryFileAndId[url]) {
              routeObj = {
                name: this.$route.name,
                query: extend({}, this.$route.query, {
                  ebook_category_content_id: categoryFileAndId[url],
                  anchor: anchor
                })
              };
            } else if (url) {
              let fileName = url.match(/\/?([^/]+)$/)[1];
              for (let i in categoryFileAndId) {
                if (i.indexOf(fileName) !== -1) {
                  routeObj = {
                    query: {
                      ebook_category_content_id: categoryFileAndId[i],
                      anchor: anchor
                    }
                  };
                  break;
                }
              }
            } else if (anchor) {
              routeObj = {
                query: {
                  anchor: anchor
                }
              };
            }
            if ( !isEmpty(routeObj)) {
              routeObj = extend({
                name: this.$route.name,
              }, routeObj, {
                query: extend({}, this.$route.query, routeObj.query)
              });
              this.$router.replace(routeObj);
            }

            break;
          }

        }
      },
      // 获取 章节
      getChapter(query) {
        this.actionEbookChapterHtml(query).then(()=>{
          this.anchorToPosition();
        });
      },
      setFree(_action,_id){
        this.actionEBookSetFree({
          ebook_id: this.$route.query.ebook_id,
          ebook_category_id: _id,
          is_free:_action
        }).then(() => {
          this.$message({
            type: 'success',
            message: '设置成功!'
          });
          this.actionEbookChapterList({
            ebook_id: this.$route.query.ebook_id,
            type: this.$route.query.type ? this.$route.query.type : '',
          });
        });
      },
      //提交订单
      submitOrder() {
        this.bookPurchaseVisible = false;
        this.purchase = 2
      },
      // 页面锚定
      anchorToPosition() {
        this.$nextTick(()=>{
          let anchor = this.$route.query.anchor;
          if (!anchor) {
            global.scrollTo(0, 0);
          } else {
            let root = this.$refs['book_container'];
            each([`#${anchor}`, `[name='${anchor}']`, `[id*='${anchor}']`, `[name*='${anchor}']`], (item) => {
              let anchor = root.querySelector(item);
              if (anchor) {
                let top = global.document.documentElement.scrollTop + anchor.getBoundingClientRect()['top'] - 120;
                global.scrollTo(0, top)
                return false;
              }
            });
          }
        });
      },
      initPage() {
        let query = this.$route.query;

        this.actionEbookChapterList({
          ebook_id: query.ebook_id,
          type: this.$route.query.type ? this.$route.query.type : '',
        });

        if (query.ebook_category_content_id) {
          this.actionEbookChapterHtml({
            ebook_id: this.$route.query.ebook_id,
            ebook_category_content_id: query.ebook_category_content_id,
            type: this.$route.query.type ? this.$route.query.type : '',
          }).then(()=>{
            this.anchorToPosition();
          });
        }

        this.publisherEBookGetDetailDataPort({
          ebook_id: this.$route.query.ebook_id,
          type: this.$route.query.type ? this.$route.query.type : '',
        }).then((result) => {
          if (!query.ebook_category_content_id) {
            this.actionEbookChapterHtml({
              ebook_id: query.ebook_id,
              ebook_category_content_id: result.nav[0],
              type: this.$route.query.type ? this.$route.query.type : '',
            }).then(()=>{
              this.anchorToPosition();
            });
          }
        });
      }
    },
    created() {
      this.initPage();
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .ebookhtml .center img{
    max-width: 100%;
    height: auto;
  }
  .book-preview-container {

    .book-catalog {
      position: fixed;
      width: 360px;
      top: 110px;
      height: calc(100% - 150px);
      background-color: #f8f8fa;
      overflow-x: hidden;
      overflow-y: auto;


      &::-webkit-scrollbar {
        width: 8px;
        display: none
      }

      &:hover::-webkit-scrollbar {
        display: block
      }

      &::-webkit-scrollbar-thumb, &::-webkit-scrollbar-thumb:hover {
        border-radius: 4px
      }
    }

    .book-render {
      padding-left: 360px;
      min-height: 800px;
    }
  }

  .cover-layer-center .caver-layer-img > img {
    display: block;
    width: 100%;
    height: 100%
  }


  .bottom-toolbar-container .toolbar-wrap > a {
    display: block;
    width: 100%;
    height: 34px;
    margin: 13px auto;
    text-align: center;
    line-height: 34px;
    font-size: 14px;
    color: #fff !important;
    border-radius: 17px
  }

  .bottom-toolbar-container .toolbar-wrap > a:hover {
    text-decoration: none;
    opacity: .8
  }

  .bottom-toolbar-container .toolbar-wrap .upgrade-membership {
    background-color: #ff982d
  }

  .screen-tips-wrap .upgrade-wrap > a {
    display: block;
    height: 32px
  }

  .screen-tips-wrap .upgrade-wrap > a:hover {
    opacity: .8;
    text-decoration: none;
  }



  .toc-item {
    line-height: 48px;
    flex:1;
    height:48px;

    a {
      color: #333;
      border-color: rgba(51, 51, 51, 0.1);
      height:48px;
    }
  }

  .text {
    display: block;
    margin: 0 28px 0 20px;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    border-bottom: 1px solid #e1e6f0
  }

  .text:hover {
    -webkit-transition: all .1s;
    transition: all .1s;
    opacity: .7;
    text-decoration: none;
  }

  .text-active {
    color: #0f88eb;
    display: block;
    margin: 0 28px 0 20px;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    border-bottom: 1px solid #e1e6f0;
  }

  .toc-item .arrow-slide {
    position: absolute;
    left: 14px;
    top: 0;
    width: 36px;
    height: 48px;
    cursor: pointer;
    z-index: 9;
    display: none;

    &:before {
      content: '';
      position: absolute;
      top: 12px;
      left: 6px;
      width: 24px;
      height: 24px;
      transform: rotate(90deg);
    }
  }

  .chapterContent{
    height: 48px;
    line-height: 48px !important;
    display: inline-block;
  }

  .chapter_content_right{
    position: absolute;
    left: 280px;
    width:70px;
  }

  .wd240{
    width:240px;
  }

  .nav-level-1 .text {
    font-weight: 700
  }

  .nav-level-1 .db .chapter_content{
    width:240px;
    overflow: hidden;
    display: inline-block;
  }

  .nav-level-2 .text {
    padding-left: 30px;
    position: relative;
    font-weight: 400
  }

  .nav-level-2 .arrow-slide {
    position: absolute;
    left: 50px;
    top: 0;
    width: 36px;
    height: 48px;
    cursor: pointer;
    z-index: 9
  }

  .nav-level-2 .db .chapter_content{
    width:210px;
    overflow: hidden;
    display: inline-block;
  }
  ::-webkit-input-placeholder {
    color: #949494;
    font-size: 12px
  }

  ::-webkit-scrollbar-thumb {
    background-color: #d7d7d7;
    height: 50px;
    outline-offset: -2px;
    outline: 1px solid #fff;
    -webkit-border-radius: 4px;
    border: 2px solid transparent
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #8c8c8c;
    height: 50px;
    -webkit-border-radius: 4px;
    text-decoration: none;
  }

  ::-webkit-scrollbar {
    width: 4px;
    height: 8px
  }

  ::-webkit-scrollbar-track-piece {
    background-color: transparent;
    -webkit-border-radius: 0
  }

  .view-next-btn {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #e4e4e4
  }

  .view-next-btn .is-end {
    font-size: 16px;
    line-height: 30px;
    color: #999
  }

  .view-next-btn .is-next {
    font-size: 16px;
    font-weight: 700;
    color: #42a5f5;
    line-height: 30px;
    cursor: pointer;
  }
  .ebookhtml {
    color: #333333 !important;
    font-family: Microsoft Yahei, Heiti SC, Heiti TC !important;
    line-height: 1.3;
    text-align: justify;
    min-height: 400px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .align-center{
    line-height:300px;
    text-align: center;
    font-size: 24px;
  }
  .dialog_p{
    font-size: 18px;
  }
  .dialog_detail{
    height: 100px;
    background-color: #EBEEF5;
  }
  .dialog_img{
    width: 160px;
    height: 80px;
    margin-left: 10px;
    margin-top: 10px;
  }
  .dialog_name{
    font-size: 16px;
  }
  .dialog_price{
    margin-top: 40px;
    font-size: 16px;
  }
  .dialog_height{
    height: 300px;
  }
  .dialog_div{
    text-align: right;
  }
  .color-grey{
    color:#bfcbd9;
  }
  .user-select{
    -moz-user-select:none; /* Firefox私有属性 */
    -webkit-user-select:none; /* WebKit内核私有属性 */
    -ms-user-select:none; /* IE私有属性(IE10及以后) */
    -khtml-user-select:none; /* KHTML内核私有属性 */
    -o-user-select:none; /* Opera私有属性 */
    user-select:none;
  }
</style>

<style scoped>
  >>> .ebookhtml p {
    text-indent: 2em;
    margin-top: 5px;
    margin-bottom: 5px;
    display: block;
    -webkit-margin-before: 1em;
    -webkit-margin-after: 1em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
    font-size: 1.0em !important;
    color: #333333;
    line-height: 1.75 !important;
    font-family: Microsoft Yahei, Heiti SC, Heiti TC !important;
    font-weight: normal !important;
    position: static !important;
  }

  >>>.ebookhtml h1 {
    font-size: 2.0em !important;
    color: #333 !important;
    line-height: 1.75 !important;
    font-weight: normal !important;
    position: static !important;
  }

  >>>.ebookhtml h2 {
    font-size: 1.9em !important;
    color: #333 !important;
    line-height: 1.70 !important;
    font-weight: normal !important;
    position: static !important;
  }

  >>>.ebookhtml h3 {
    font-size: 1.8em !important;
    color: #333 !important;
    line-height: 1.75 !important;
    font-weight: normal !important;
    position: static !important;
  }

  >>> a {
    color: #42a5f5;
    text-decoration: none;
    transition: opacity 300ms ease;
  }

  >>> a:hover {
    color: #42a5f5;
    opacity: 0.6;
  }
  >>>.current {
    color: #42a5f5 !important;
  }

  >>>.ebookhtml img, >>>.ebookhtml svg {
    max-width: 90%;
    margin-left: auto;
    margin-right: auto;
  }

  >>> .el-tree-node__content {
    height: 48px;
  }

  >>> .el-tree-node__content {
    border-bottom: 1px solid #e1e6f0;
    background-color: rgb(248, 248, 250);
  }
  >>>.el-tag{
    color:#fff;
    z-index:100;
  }
  .freeChapter{
    background-color: #67C23A;
    border:1px solid #67C23A;
  }
  .notFreeChapter{
    background-color: #F56C6C;
    border:1px solid #F56C6C;
  }
  .el-loading-spinner p {
    text-align: center !important;
  }
</style>
